import { ObjectiveFormValues } from './ObjectiveForm';

export const objectiveInitialValues: ObjectiveFormValues = {
  name: '',
  ownerId: null, // ownerId, i.e. user.id
};
